import { render } from "./Vote.vue?vue&type=template&id=0538ef5e&ts=true"
import script from "./Vote.vue?vue&type=script&lang=ts"
export * from "./Vote.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__